import { Box, Container, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { YouTubeChannel } from "./youtubechannel.types";
import { youtubeChannelsMock } from "./mockData";
import ChannelBasicInfoSection from "./components/ChannelBasicInfo";
import ReauthenticateButton from "./components/ReauthenticateButton";
import ChannelOAuthSection from "./components/ChannelOAuthSection";
import ChannelScopesSection from "./components/ChannelScopeSection";

export default function YouTubeChannelViewPage() {
  const { id } = useParams();

  const channel = useMemo<YouTubeChannel | undefined>(() => {
    return youtubeChannelsMock.find((item) => item.id === Number(id));
  }, [id]);

  const handleReauthenticate = () => {
    if (!channel) return;

    console.log("Re-authenticate channel:", channel);
    // Example:
    // if (channel.reauth_url) {
    //   window.location.href = channel.reauth_url;
    // }
  };

  if (!channel) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Channel not found
        </Typography>
        <Typography color="text.secondary">
          The requested YouTube channel does not exist.
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        spacing={2}
        mb={3}
      >
        <Box>
          <Typography variant="h4" fontWeight={700}>
            View YouTube Channel
          </Typography>
          <Typography color="text.secondary">
            Review channel information and OAuth setup
          </Typography>
        </Box>

        <ReauthenticateButton
          needsReauth={channel.needs_reauth}
          onClick={handleReauthenticate}
        />
      </Stack>

      <Stack spacing={3}>
        <ChannelBasicInfoSection channel={channel} />
        <ChannelOAuthSection channel={channel} />
        <ChannelScopesSection scopes={channel.scopes} />
      </Stack>
    </Container>
  );
}
